var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFavoritesSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7326 1.62909C10.8438 1.41038 11.1562 1.41039 11.2674 1.62909L13.9753 6.95468C14.0768 7.15434 14.2678 7.29335 14.4889 7.32866L20.3778 8.26866C20.6193 8.30722 20.7157 8.60313 20.5431 8.77652L16.3271 13.0134C16.1697 13.1716 16.0972 13.3954 16.1318 13.6158L17.0608 19.5273C17.0988 19.7694 16.8463 19.9525 16.628 19.841L11.3183 17.13C11.1184 17.0279 10.8816 17.0279 10.6817 17.13L5.37199 19.841C5.15372 19.9525 4.90116 19.7694 4.9392 19.5273L5.86819 13.6158C5.90284 13.3954 5.83029 13.1716 5.67287 13.0134L1.45688 8.77652C1.28434 8.60312 1.38069 8.30722 1.62224 8.26866L7.51106 7.32866C7.73224 7.29336 7.92317 7.15434 8.02469 6.95468L10.7326 1.62909Z",
    fill: "#EEEEEE",
    stroke: "#EEEEEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFavoritesSolid);
export default __webpack_public_path__ + "static/media/ic_favorites_solid.a4fdea08286ec4496fa52ae1088a92c0.svg";
export { ForwardRef as ReactComponent };